import { t, Trans } from "@lingui/macro";
import { UiTypography } from "@smp/ui";
import { FC } from "react";

import { FormTextFieldV2 } from "@/components/form/form_text_field_v2";

export interface IGeneralParamsProps {
  classes?: Partial<{
    group: string;
    row: string;
  }>;
}

export const GeneralParams: FC<IGeneralParamsProps> = ({ classes }) => (
  <div className={classes?.group}>
    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>What do you do?</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.occupation"
          placeholder={t`__advisor.create_agent.form.placeholder.occupation`}
        />
      </div>
    </div>

    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>Who is your client?</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.target_audience"
          placeholder={t`__advisor.create_agent.form.placeholder.target_audience`}
        />
      </div>
    </div>

    <div className={classes?.row}>
      <UiTypography variant="h5">
        <Trans>What customer problems does your business solve?</Trans>
      </UiTypography>

      <div>
        <FormTextFieldV2
          fullWidth
          multiline
          variant="outlined"
          name="context.problem"
          placeholder={t`__advisor.create_agent.form.placeholder.problem`}
        />
      </div>
    </div>
  </div>
);
